<div class="wrapper position-relative">
  <span class="icon icon-calendar"></span>
  <input type="text" readonly class="form-control date-time" [attr.placeholder]="placeholder" [value]="model" [formControl]="control" autocomplete="off">
  <span *ngIf="model && clear" (click)="onClickClear()" class="addon datetime-placeholder datetime-placeholder-clear">
    <span class="text-primary">Clear</span>
  </span>
  <span *ngIf="!clear" class="fas fa-chevron-down position-absolute"></span>
</div>
<input-errors *ngIf="validationService && validator" [control]="control" [service]="validationService"></input-errors>
